import { render, staticRenderFns } from "./VSpinner.vue?vue&type=template&id=6c2270b8&scoped=true"
import script from "./VSpinner.vue?vue&type=script&lang=js"
export * from "./VSpinner.vue?vue&type=script&lang=js"
import style0 from "./VSpinner.vue?vue&type=style&index=0&id=6c2270b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2270b8",
  null
  
)

export default component.exports